module.exports = __webpack_public_path__ + "img/ic_store_function_img2.420ecfe7.png";